import type { UserAvatarProps } from "./types-user-avatar";
import { useUserAvatar } from "./use-user-avatar";
import { UserAvatarView } from "./view-user-avatar";

/**
 * Avatar do usuário: foto quando há uma e ela carrega; caso contrário as iniciais
 * do nome (ou o ícone de usuário quando o nome é vazio). Nunca exibe erro por foto.
 */
export function UserAvatar(props: UserAvatarProps) {
  const vm = useUserAvatar(props);

  return <UserAvatarView {...vm} />;
}

export { getInitials, isEmail } from "./user-avatar.utils";
export type * from "./types-user-avatar";
